import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import AuthReducer from "../components/login/LoginSlice";
import financialYearReducer from "../Redux/financialYearSlice";
import enrollmentPolicyReducer from "../Redux/enrollmentPolicySlice";

const persistConfig = {
  key: "vb_corporate_root",
  version: 15, // Change this version when a new build is created with breaking state changes
  storage,
  // blacklist: [], // Add slices here if you want to exclude them from persistence
  migrate: (state) => {
    // If the persisted version is outdated, return undefined to clear the state
    if (state?._persist?.version !== persistConfig.version) {
      return Promise.resolve(undefined);
    }
    return Promise.resolve(state);
  },
};

const rootReducer = combineReducers({
  cauth: AuthReducer,
  financialYear: financialYearReducer,
  enrollmentPolicy: enrollmentPolicyReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/PURGE"],
      },
    }),

  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export default store;